import meta from '../../package.json';
import { Environment } from './env.type';

export const baseEnvironment: Environment = {
    envName: 'base',
    graphqlUrl: null,
    clientName: 'Painel MDO',
    clientVersion: meta.version,
    clientPlatform: 'Web',
    language: 'pt-br',
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
};
